import { Slot } from 'expo-router';

import { GoogleTagManagerIntegration } from '../../events/growth/GoogleTagManagerIntegration';
import { MetaIntegration } from '../../events/growth/MetaIntegration';
import { VisitorProvider } from '../../user/providers/VisitorProvider';

// Should include any relevant things found in the "custom code" configuration in Webflow
// See https://webflow.com/dashboard/sites/fruitful-2024/custom-code
const GrowthMarketingIntegrations = () => {
    return (
        <>
            <GoogleTagManagerIntegration />
            <MetaIntegration />
        </>
    );
};

export default function SignUpLayout() {
    return (
        <>
            <GrowthMarketingIntegrations />
            <VisitorProvider>
                <Slot />
            </VisitorProvider>
        </>
    );
}
